import React, { Fragment, useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import OperatorLists from './OperatorLists';
import FavoriteLists from '../Favorite/FavoriteLists';
import FavoriteDialog from '../Favorite/FavoriteDialog';
import AppButton from '../../styles/common/AppButton';
import addImage from '../../images/common/add_white_24dp.svg';
import BlackboardListDialog from '../BlackboardList/Dialog';
import { PAGE_PATH, REMOTE_COMMAND } from '../../lib/constants';
import { isGuest } from '../../lib/tools';
import ContactTabs from './ContactTabs';
import ContactActions from './ContactActions';
import SearchBox from '../Parts/SearchBox';
import {
  Main,
  ContentsTitle,
  Contents,
  UpperContent,
  ContactActionsWrapper,
  ButtonImage,
  UserSearchWrapper,
  Lists,
  ContactsWrapper,
  NotAllowedMessage,
  OperatorContentContainer,
} from './styles/OperatorPageStyles';
import CollHistoryComponent from '../CallHistory/CallHistoryComponent';

const OPERATOR_TAB = {
  operators: 'operators',
  favorites: 'favorites',
  callHistory: 'callHistory',
};
const getUpperHeight = () => {
  const obj = document.getElementById('OperatorsUpperContent');
  return (obj && obj.clientHeight) || 0;
};

const OperatorPage = ({ redirect }) => {
  const dispatch = useDispatch();
  const {
    apiToken,
    userInfo,
    operators,
    favorites,
    favorite,
    searchOptions,
    favoriteNamePartial,
    operatorNamePartial,
    remoteMembers,
    innerRole,
    isOpenBlackboardList,
  } = useSelector(state => ({
    apiToken: state.main.apiToken,
    userInfo: state.main.userInfo,
    operators: state.operator.operators,
    favorites: state.favorite.favorites,
    favorite: state.favorite.favorite,
    searchOptions: state.operator.searchOptions,
    favoriteNamePartial: state.favorite.namePartial,
    operatorNamePartial: state.operator.namePartial,
    remoteMembers: state.operator.remoteMembers,
    innerRole: state.main.innerRole,
    isOpenBlackboardList: state.main.isOpenBlackboardList,
  }));

  const notAllowedRemoteCall = isGuest(userInfo.role) && operators.length <= 1;
  const [currentTab, setCurrentTab] = useState(OPERATOR_TAB.operators);
  const [upperHeight, setUpperHeight] = useState(getUpperHeight());
  const operatorListActive = currentTab === OPERATOR_TAB.operators;
  const favoriteListActive = currentTab === OPERATOR_TAB.favorites;
  const callHistoryActive = currentTab === OPERATOR_TAB.callHistory;
  const openFavoriteDialog = param =>
    dispatch({ type: 'OPEN_FAVORITE_DIALOG', param });
  const toggleCheckbox = id => dispatch({ type: 'CHECK_OPERATOR', id });
  const resetCheckbox = () => dispatch({ type: 'RESET_CHECK_OPERATOR' });
  const checkAll = checked => dispatch({ type: 'CHECK_ALL_OPERATOR', checked });
  useEffect(() => setUpperHeight(getUpperHeight() + 10), [remoteMembers]);
  const stringifyOperatorIds =
    (remoteMembers.length > 0 &&
      JSON.stringify(remoteMembers.map(member => member.operatorId))) ||
    '';
  const [operatorIdsForBlackboard, setOperatorIdsForBlackboard] =
    useState(stringifyOperatorIds);
  const [favoriteIdForBlackboard, setFavoriteIdForBlackboard] = useState(0);
  const onRemoteSupportEnd = () => {
    // onRemoteSupportEnd(
    //   dispatch,
    //   formatMessage,
    //   apiToken,
    //   operatorId,
    //   deviceId,
    // );
  }; // TODO

  const handleOpenBlackboardList = () => {
    dispatch({ type: 'OPEN_BLACKBOARD_LIST_DIALOG' });
  };
  return (
    <Main className="operatorPage">
      {isOpenBlackboardList && (
        <BlackboardListDialog
          dispatch={dispatch}
          apiToken={apiToken}
          onRemoteSupportEnd={onRemoteSupportEnd}
          stringifyOperatorIds={operatorIdsForBlackboard}
          favoriteId={favoriteIdForBlackboard}
          isGroup
          resetCheckbox={resetCheckbox}
        />
      )}
      {favorite && (
        <FavoriteDialog
          apiToken={apiToken}
          dispatch={dispatch}
          userInfo={userInfo}
        />
      )}
      <Contents>
        <ContentsTitle>
          <FormattedMessage id="operator.dashboard.title" />
        </ContentsTitle>
        {notAllowedRemoteCall && (
          <NotAllowedMessage>
            <FormattedMessage id="operator.dashboard.message.notAllowed" />
          </NotAllowedMessage>
        )}
        <ContactsWrapper hidden={notAllowedRemoteCall}>
          <UpperContent id="OperatorsUpperContent">
            {userInfo.operatorLicenseInfo.isRemoteOperatorEnabled && (
              <Fragment key="operator-upper-content">
                <ContactTabs
                  currentTab={currentTab}
                  setCurrentTab={setCurrentTab}
                />
                <ContactActionsWrapper hidden={!operatorListActive}>
                  <ContactActions
                    remoteMembers={remoteMembers}
                    openBlackboardList={() => {
                      setOperatorIdsForBlackboard(stringifyOperatorIds);
                      handleOpenBlackboardList();
                    }}
                    toggleCheckbox={toggleCheckbox}
                    resetCheckbox={resetCheckbox}
                    remoteUrl={`${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.caller}?operatorIds=${stringifyOperatorIds}`}
                  />
                </ContactActionsWrapper>
              </Fragment>
            )}
          </UpperContent>
          {operatorListActive && (
            <Fragment key="operator-content-list">
              <OperatorContentContainer>
                <SearchBox
                  defaultValue={operatorNamePartial}
                  onChange={e =>
                    dispatch({
                      type: 'FILTER_OPERATOR_NAME',
                      namePartial: e.target.value,
                    })
                  }
                />
              </OperatorContentContainer>
              <Lists upperHeight={upperHeight}>
                <OperatorLists
                  operators={operators}
                  onSelect={operatorId => {
                    redirect(`/ds/timelinetile/${operatorId}`);
                  }}
                  searchOptions={searchOptions}
                  onChangeSort={() =>
                    dispatch({
                      type: 'OPERATOR_CHANGE_SORT',
                    })
                  }
                  onCheck={id => toggleCheckbox(id)}
                  remoteMembers={remoteMembers}
                  onAllCheck={checkAll}
                  userInfo={userInfo}
                  innerRole={innerRole}
                  namePartial={operatorNamePartial}
                />
              </Lists>
            </Fragment>
          )}
          {favoriteListActive && (
            <Fragment key="operator-content-favorite">
              <UserSearchWrapper>
                <SearchBox
                  defaultValue={favoriteNamePartial}
                  onChange={e =>
                    dispatch({
                      type: 'FILTER_FAVORITE_NAME',
                      namePartial: e.target.value,
                    })
                  }
                />
                <AppButton
                  small
                  width="120px"
                  className="button"
                  onClick={openFavoriteDialog}
                >
                  <ButtonImage src={addImage} alt="addFavorite" />
                  <FormattedMessage id="operator.dashboard.favorites.add" />
                </AppButton>
              </UserSearchWrapper>
              <Lists upperHeight={60}>
                <FavoriteLists
                  userInfo={userInfo}
                  favorites={favorites}
                  openFavoriteDialog={openFavoriteDialog}
                  openBlackboardList={(operatorIds, favoriteId) => {
                    setOperatorIdsForBlackboard(operatorIds);
                    setFavoriteIdForBlackboard(favoriteId);
                    handleOpenBlackboardList();
                  }}
                />
              </Lists>
            </Fragment>
          )}
          {callHistoryActive && <CollHistoryComponent />}
        </ContactsWrapper>
      </Contents>
    </Main>
  );
};

OperatorPage.propTypes = {
  redirect: PropTypes.func.isRequired,
};

export default OperatorPage;
